// =====================================================================================
// FILE: src/utils/statusColors.js
// Content Status Workflow
// =====================================================================================

// =====================================================================================
// MATCHFLOW BUILDER (Club View) - 4 statuses:
// - New Submission (grey/white) - default, editable
// - Rejected (red) - needs club attention, editable
// - Approved by Lumen8 (green) - LOCKED
// - Content Unlocked (purple) - unlocked for editing
//
// OPERATOR VIEW (Per Asset) - 5 statuses:
// - Ready for Testing (orange) - 🔴 new content needs Xpression ingest
// - Ready for Playout (blue) - 🟢 already in Xpression
// - Rejected (red) - issue found
// - Approved by Lumen8 (green) - signed off
// - Content Unlocked (purple) - unlocked for editing
// =====================================================================================

export function statusRowColor(status) {
  const s = String(status || "").trim().toLowerCase();
  
  // Red - rejected, needs attention
  if (s.includes("rejected")) return "#fde2e2";
  
  // Green - approved/complete
  if (s.includes("approved by lumen8") || s.includes("approved")) return "#e6f7e9";
  
  // Orange - ready for testing (new content needs ingest)
  if (s.includes("ready for testing")) return "#ffedd5";
  
  // Blue - ready for playout (already in Xpression)
  if (s.includes("ready for playout")) return "#dbeafe";
  
  // Purple - content unlocked (unlocked for editing)
  if (s.includes("content unlocked")) return "#f3e8ff";
  
  // === Legacy statuses (backward compatibility) ===
  // Yellow - change alert
  if (s.includes("change alert")) return "#fff4d6";
  // Orange - resubmitted
  if (s.includes("resubmitted")) return "#ffedd5";
  // Purple - sent to incoder
  if (s.includes("sent to incoder")) return "#f3e8ff";
  // Blue-grey - example content
  if (s.includes("example content")) return "#f1f5f9";
  
  // Default - New Submission (white/light grey)
  return "#ffffff";
}

export function statusBorderColor(status) {
  const s = String(status || "").trim().toLowerCase();
  
  // Red
  if (s.includes("rejected")) return "#f7b5b5";
  
  // Green
  if (s.includes("approved by lumen8") || s.includes("approved")) return "#a8e1b4";
  
  // Orange
  if (s.includes("ready for testing")) return "#fdba74";
  
  // Blue
  if (s.includes("ready for playout")) return "#93c5fd";
  
  // Purple - content unlocked
  if (s.includes("content unlocked")) return "#d8b4fe";
  
  // === Legacy statuses (backward compatibility) ===
  if (s.includes("change alert")) return "#ffd58a";
  if (s.includes("resubmitted")) return "#fdba74";
  if (s.includes("sent to incoder")) return "#d8b4fe";
  if (s.includes("example content")) return "#cbd5e1";
  
  // Default
  return "#e0e0e0";
}

// ✅ Check if a row is locked (cannot be edited by club)
// "Approved by Lumen8" and "Example Content" lock the row in MatchFlow Builder
export function isRowLocked(status) {
  const s = String(status || "").trim().toLowerCase();
  return s.includes("approved by lumen8") || s.includes("example content");
}

export function stop(e) {
  e.preventDefault();
  e.stopPropagation();
}
